export default __webpack_public_path__ + "static/media/female_3.dfda4689.png";